import useOfferOptions from './useOfferOptions';
import useOptionsList from './useOptionsList';

export default function useOffersSorting(offersSort) {
  const optionsList = useOptionsList(offersSort);
  const offerOptions = useOfferOptions(optionsList);

  return { optionsList, offerOptions };
}
